import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    $("#insurer_avatar").filestyle({ buttonText: "Selecione uma imagem" });
  }
}
